var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoMiddle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 119.8 120.8",
    style: {
      enableBackground: "new 0 0 119.8 120.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#32285B;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#E30613;}\n\t.st3{fill:#DEDC00;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M59.8,65.9H1c0,8,3.3,32.5,26.9,45.1c1.8,1,3.8,1.7,5.8,2.2h-0.5v4.1c0,1.5,2.1,2.7,4.7,2.7h43.7 c2.6,0,4.7-1.2,4.7-2.7v-4.1h-0.5c2-0.5,4-1.2,5.8-2.2c23.6-12.7,26.9-37.1,26.9-45.1L59.8,65.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M21,78.5h4.2v3.2l1-1c1.4-1.6,3.4-2.5,5.5-2.4c2.3-0.2,4.3,1.3,4.8,3.6h0.2l1.2-1.1c1.4-1.5,3.4-2.4,5.5-2.4 c3.2,0,5.1,1.8,5.1,6.1v12.5h-4.1V84.9c0-2.3-0.8-3.1-2.3-3.1s-3.1,1.4-4.1,2.3l-1,0.9v11.8h-4.1V84.9c0-2.3-0.9-3.1-2.4-3.1 s-3,1.4-4.1,2.3l-1,0.9v11.8H21V78.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M52.9,89.6v-3.6c0-5.1,3.7-7.9,8.5-7.9c4.1,0,7.1,1.5,7.1,5.6c0,3.6-2.5,5.3-6.2,5.3h-5.3v0.7 c0,2.8,2,3.8,4.5,3.8c1.9,0,3.7-0.4,5.4-1h0.3v3.5c-1.9,0.7-3.9,1-5.9,1.1C56.5,97,52.9,94.9,52.9,89.6z M57.1,86.3h4.6 c2.2,0,2.9-0.8,2.9-2.4c0-1.8-1.3-2.2-3.2-2.2c-2.7,0-4.3,1.2-4.3,4.3V86.3z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M72.2,90.8v-3.2c0-5.7,4.5-9.2,9.7-9.2h6.5v18.3h-4.2v-3l-1.3,1.1c-1.4,1.4-3.2,2.1-5.2,2.2 C74.5,97,72.2,95,72.2,90.8z M84.2,90.3v-8.4h-2.1c-3.5,0-5.8,2.1-5.8,5.8v2.8c0,2.3,1,3,2.5,3s3.2-1.3,4.3-2.2L84.2,90.3z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M94.4,75.1h-2.9v-3.5h7.1v25.1h-4.1V75.1z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M21.2,60.9v-8.2h0.6c4.2,0.9,8.5,1.4,12.9,1.5c4.7,0,9.3-1.1,9.3-5.1c0-2.9-2.5-4.1-5.4-4.8L32,42.8 c-7-1.7-10.9-5.5-10.9-11.9c0-8.5,7.8-13,18.9-13c3.9,0,7.8,0.5,11.7,1.3v8.2h-0.6c-3.8-0.7-7.6-1.1-11.4-1.2 c-4.6,0-8.6,1.1-8.6,4.5c0,3.1,2.3,3.6,5,4.3l5.8,1.3C48.4,37.8,54,40.6,54,49c0,10.3-9.3,13.4-19.3,13.4 C30.2,62.4,25.6,61.9,21.2,60.9z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M57.9,39.9c0-14,7-21.9,20.3-21.9c13.9,0,20.3,7.9,20.3,21.9c0,15.2-6.6,22.6-20.3,22.6S57.9,55,57.9,39.9z  M88.8,39.9c0-8.9-2.6-13.4-10.5-13.4S67.7,31,67.7,39.9S70.4,54,78.3,54S88.8,48.7,88.8,39.9L88.8,39.9z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M99.1,19.8c0.7-4.3,3.8-13.1,17.4-16.3C116.2,7.7,113.8,16.5,99.1,19.8z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M114,6.3c-1.1,3.5-4,8-12,10.6c0.3-0.8,0.6-1.5,1-2.2C105.2,10.9,108.9,8,114,6.3 M118.5,1 C96.1,4.9,96.9,22.3,96.9,22.3C120.8,18.4,118.5,1,118.5,1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMiddle);
export default __webpack_public_path__ + "static/media/logo-middle.0fee7cd71f3d6aa0432171288bb35e0f.svg";
export { ForwardRef as ReactComponent };